export default "__VITE_ASSET__PV8tV8n9__"